import { cva } from 'class-variance-authority'

export const overlayStyles = cva(`
  fixed
  inset-0
  z-50
  bg-black/50
  data-[state=open]:animate-in
  data-[state=closed]:animate-out
  data-[state=closed]:fade-out-0
  data-[state=open]:fade-in-0
`)

export const contentStyles = cva(`
  fixed
  left-[50%]
  top-[50%]
  z-50
  grid
  w-full
  max-w-lg
  translate-x-[-50%]
  translate-y-[-50%]
  gap-4
  border
  border-neutral-200
  rounded-xl
  p-6
  bg-neutral-0
  shadow-lg
  duration-200
  data-[state=open]:animate-in
  data-[state=closed]:animate-out
  data-[state=closed]:fade-out-0
  data-[state=open]:fade-in-0
  data-[state=closed]:slide-out-to-top-full
  data-[state=open]:slide-in-from-top-full
  sm:rounded-lg
`)

export const headerStyles = cva(`
  flex
  flex-col
  space-y-2
  text-neutral-700
  text-lg
  sm:text-left
`)

export const footerStyles = cva(`
  flex
  flex-col-reverse
  sm:flex-row
  sm:justify-end
  sm:space-x-2
`)

export const titleStyles = cva(`
  h1
  text-neutral-700
`)

export const descriptionStyles = cva(`
  text-md
  text-neutral-600
`)
